(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~message"],{

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/base/vc-notification/index.js + 2 modules
var vc_notification = __webpack_require__(105);

// CONCATENATED MODULE: ./src/components/message/assets/megui-fill-info.svg
/* harmony default export */ var megui_fill_info = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KICA8c3ZnIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHBhdGggcGlkPSIwIiBmaWxsPSJub25lIiBkPSJNMCAwaDE2djE2SDB6Ii8+PHBhdGggcGlkPSIxIiBkPSJNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHptLjYgMTEuOWMwIC4xLS4xLjEtLjEuMWgtLjljLS4xIDAtLjEtLjEtLjEtLjFWN2MwLS4xLjEtLjEuMS0uMWguOWMuMSAwIC4xLjEuMS4xdjQuOXpNOCA1LjdjLS41IDAtLjktLjQtLjktLjlTNy41IDQgOCA0cy45LjQuOS45LS40LjgtLjkuOHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjMTA2N0QxIiBmaWxsLW9wYWNpdHk9IjEiLz4KICA8L3N2Zz4KICA=");
// CONCATENATED MODULE: ./src/components/message/assets/megui-fill-check-circle.svg
/* harmony default export */ var megui_fill_check_circle = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KICA8c3ZnIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHBhdGggcGlkPSIwIiBkPSJNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHptMy41IDUuNGwtMy44IDUuMmMtLjIuMy0uNy4zLS45IDBMNC41IDcuNWMtLjEtLjEgMC0uMi4xLS4yaC44Yy4yIDAgLjQuMS41LjJsMS4zIDEuOEwxMCA1LjRjLjEtLjEuMy0uMi41LS4yaC44Yy4yIDAgLjIuMS4yLjJ6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzAwQzE3MiIgZmlsbC1vcGFjaXR5PSIxIi8+CiAgPC9zdmc+CiAg");
// CONCATENATED MODULE: ./src/components/message/assets/megui-fill-close-circle.svg
/* harmony default export */ var megui_fill_close_circle = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KICA8c3ZnIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHBhdGggcGlkPSIwIiBkPSJNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHptMyAxMUg5LjhMOCA4LjkgNi4yIDExSDVzLS4xIDAtLjEtLjF2LS4xTDcuMyA4IDQuOSA1LjN2LS4xYzAtLjEuMS0uMi4xLS4yaDEuMkw4IDcuMiA5LjggNUgxMWMuMSAwIC4xLjEuMS4xdi4xTDguNyA4bDIuMyAyLjh2LjFjLjEuMSAwIC4xIDAgLjF6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0U1MzYzNSIgZmlsbC1vcGFjaXR5PSIxIi8+CiAgPC9zdmc+CiAg");
// CONCATENATED MODULE: ./src/components/message/assets/megui-fill-warn.svg
/* harmony default export */ var megui_fill_warn = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KICA8c3ZnIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHBhdGggcGlkPSIwIiBkPSJNOCAxNmM0LjQgMCA4LTMuNiA4LThzLTMuNi04LTgtOC04IDMuNi04IDggMy42IDggOCA4ek03LjQgNC4xcy4xLS4xLjItLjFoLjljLjEgMCAuMS4xLjEuMVY5YzAgLjEtLjEuMS0uMS4xaC0uOWMtLjEgMC0uMiAwLS4yLS4xVjQuMXptLjYgNi4yYy41IDAgLjkuNC45LjkgMCAuNC0uNC44LS45LjhzLS45LS40LS45LS45YzAtLjQuNC0uOC45LS44eiIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNGRjhFMjciIGZpbGwtb3BhY2l0eT0iMSIvPgogIDwvc3ZnPgogIA==");
// CONCATENATED MODULE: ./src/components/message/index.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // import './style/index.scss';

var SVG_TYPE_MAP = {
  info: megui_fill_info,
  success: megui_fill_check_circle,
  error: megui_fill_close_circle,
  warning: megui_fill_warn
};
var defaultDuration = 3;
var defaultTop;
var messageInstance;
var key = 1;
var prefixCls = 'meg-message';
var transitionName = 'move-up';

var getContainer = function getContainer() {
  return document.body;
};

var maxCount;

function getMessageInstance(callback) {
  if (messageInstance) {
    callback(messageInstance);
    return;
  }

  vc_notification["a" /* default */].newInstance({
    prefixCls: prefixCls,
    transitionName: transitionName,
    style: {
      top: defaultTop
    },
    // 覆盖原来的样式
    getContainer: getContainer,
    maxCount: maxCount
  }, function (instance) {
    if (messageInstance) {
      callback(messageInstance);
      return;
    }

    messageInstance = instance;
    callback(instance);
  });
} // type NoticeType = 'info' | 'success' | 'error' | 'warning' | 'loading';


function notice(args) {
  var duration = args.duration !== undefined ? args.duration : defaultDuration;
  var iconType = {
    info: {
      icon: 'megui-fill-info',
      color: ''
    },
    success: {
      icon: 'megui-fill-check-circle',
      color: '#00C172'
    },
    error: {
      icon: 'megui-fill-close-circle',
      color: '#E53635'
    },
    warning: {
      icon: 'megui-fill-warn',
      color: '#FF8E27'
    },
    loading: {
      icon: 'megui-fill-loading',
      color: '#464551'
    }
  }[args.type];
  var target = args.key || key++;
  var closePromise = new Promise(function (resolve) {
    var callback = function callback() {
      if (typeof args.onClose === 'function') {
        args.onClose();
      }

      return resolve(true);
    };

    getMessageInstance(function (instance) {
      instance.notice({
        key: target,
        duration: duration,
        style: {},
        content: function content(h) {
          var iconNode = h("img", {
            "class": "".concat(prefixCls, "-icon-img"),
            attrs: {
              src: SVG_TYPE_MAP[args.type]
            }
          });
          var switchIconNode = iconType ? iconNode : '';
          return h("div", {
            "class": "".concat(prefixCls, "-custom-content").concat(args.type ? " ".concat(prefixCls, "-").concat(args.type) : '')
          }, [args.icon ? typeof args.icon === 'function' ? args.icon(h) : args.icon : switchIconNode, h("span", [typeof args.content === 'function' ? args.content(h) : args.content])]);
        },
        onClose: callback
      });
    });
  });

  var result = function result() {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };

  result.then = function (filled, rejected) {
    return closePromise.then(filled, rejected);
  };

  result.promise = closePromise;
  return result;
} // type ConfigContent = React.ReactNode | string;
// type ConfigDuration = number | (() => void);
// export type ConfigOnClose = () => void;


function isArgsProps(content) {
  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
} // export interface ConfigOptions {
//   top?: number;
//   duration?: number;
//   prefixCls?: string;
//   getContainer?: () => HTMLElement;
//   transitionName?: string;
// }


var api = {
  open: notice,
  config: function config(options) {
    if (Object.prototype.toString.call(options) !== '[object Object]') return;

    if (options.top !== undefined) {
      defaultTop = options.top;
      messageInstance = null; // delete messageInstance for new defaultTop
    }

    if (options.duration !== undefined) {
      defaultDuration = options.duration;
    }

    if (options.prefixCls !== undefined) {
      prefixCls = options.prefixCls;
    }

    if (options.getContainer !== undefined) {
      getContainer = options.getContainer;
    }

    if (options.transitionName !== undefined) {
      transitionName = options.transitionName;
      messageInstance = null; // delete messageInstance for new transitionName
    }

    if (options.maxCount !== undefined) {
      maxCount = options.maxCount;
      messageInstance = null;
    }
  },
  destroy: function destroy() {
    if (messageInstance) {
      messageInstance.destroy();
      messageInstance = null;
    }
  }
};
['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
  api[type] = function (content, duration, onClose) {
    if (isArgsProps(content)) {
      return api.open(_objectSpread(_objectSpread({}, content), {}, {
        type: type
      }));
    }

    if (typeof duration === 'function') {
      onClose = duration;
      duration = undefined;
    }

    return api.open({
      content: content,
      duration: duration,
      type: type,
      onClose: onClose
    });
  };
});
api.warn = api.warning;
/* harmony default export */ var message = __webpack_exports__["default"] = (api);

/***/ })

}]);